module.exports = __webpack_public_path__ + "static/media/ug2.cdd65516.png";